import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['menu', 'trigger']

  connect() {
    this.element.classList.add('relative')
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener('click', this.boundHandleClickOutside)
  }

  disconnect() {
    window.clearTimeout(this.hideTimer)
    document.removeEventListener('click', this.boundHandleClickOutside)
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  hide() {
    const menu = this.menuTarget
    if (this.hasTriggerTarget) this.triggerTarget.setAttribute('aria-expanded', 'false')
    menu.classList.remove('opacity-100', 'scale-100')
    menu.classList.add('opacity-0', 'scale-95')

    const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 120
    this.hideTimer = window.setTimeout(() => menu.classList.add('hidden'), delay)
  }

  toggle() {
    const menu = this.menuTarget
    const isHidden = menu.classList.contains('hidden')

    if (isHidden) {
      window.clearTimeout(this.hideTimer)
      menu.classList.remove('hidden', 'opacity-0', 'scale-95')
      menu.classList.add('opacity-100', 'scale-100')
      if (this.hasTriggerTarget) this.triggerTarget.setAttribute('aria-expanded', 'true')
    } else {
      this.hide()
    }
  }
}
